module.exports = new Promise(resolve => {
      function getEnv(envVarName) {
  return window?._envs_?.legacyApp[envVarName];
}
      const remoteUrl = getEnv("REACT_APP_MODERN_APP_LOCATION");
      const script = document.createElement('script');
      script.src = remoteUrl;
      script.onload = () => {
        // the injected script has loaded and is available on window
        // we can now resolve this Promise
        const proxy = {
          get: (request) => window.modernApp.get(request),
          init: (arg) => {
            try {
              return window.modernApp.init(arg);
            } catch(e) {
              console.log('remote container already initialized');
            }
          }
        }
        resolve(proxy);
      }
      // inject this script
      document.head.appendChild(script);
    })
    ;